import React, { useState, useEffect } from "react";
import {
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Button,
  Select,
  MenuItem,
  Typography,
  Tooltip,
  IconButton,
  InputLabel,
  FormControl,
  Box,
  TableSortLabel,
  TextField,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
import Uppy from "@uppy/core";
import HistoryIcon from "@mui/icons-material/History";
import DeleteIcon from "@mui/icons-material/Delete";
import Tus from "@uppy/tus";
import { checkStyle } from "../../services/CommonService";
import { useNavigate } from "react-router-dom";
import { TECHNICAL_DOCUMENT_LISTING_COLUMNS } from "../../utils/constant";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import SearchIcon from "@mui/icons-material/Search";
import { useForm } from "react-hook-form";
import { visuallyHidden } from "@mui/utils";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Menu from "@mui/material/Menu";
import UploadDoc from "./UploadDoc";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import download from "downloadjs";
import {
  UploadFileService,
  UploadFileServiceSoftware,
  UpdateFileServiceSoftware,
  DownloadTechDocService,
  ChangeTechDocStatusService,
  UpdateFileService,
  getTechVersion,
  DownloadTechDocHistoryService,
  deleteTechDocService
} from "../../services/TechnicalDocumentService";
import FilterAltOffSharpIcon from "@mui/icons-material/FilterAltOffSharp";
import RecordNotFound from "../../common/RecordNotFound";
import useGlobalState from "../../Context";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";

export default function TechnicalDocumentList({
  handleTableChanges,
  fetchTechnicalDocumentDetails,
  totalElements,
  techDocumentRecords,
  setLoading,
  showNotification,
  setTechDocumentRecords,
  categoryList,
  docTypeList,
  fetchAllBrandsList,
  fetchModelsDeptList,
  fetchModelsList,
  modelList,
  departmentList,
  allBrands,
  modelDescription,
  fetchBrickListOnSelectedBrandForUpload,
  brickListForUpload,
  state,
  searchClicked,
  setSearchClicked,
  setIsApiCalled,
  isApiCalled,
  setTotalElements,
  noRecord,
  fetchDocTypeList,
  setCategoryListOnBrandId,
  productFamilyList,
  fetchCategoryListOnSelectedBrand,
  categoryListOnBrandId,
  fetchProductFamilyList,
  fetchBrickListWithorWithoutFamily,
  brickList,
  brandDropDownList,
  familyList,
  brickDropdownList,
  fetchBrandSearchDropdownList,
  fetchCatSearchDropdownList,
  fetchFamSearchDropdownList,
  fetchBrickSearchDropdownList,
  modelIdData,
  deptIdData,
  selectedModelIds,
  selectedDeptIds,
  setSelectedModelIds,
  setSelectedDeptlIds,
  setModelIdData,
  setDeptIdData
}) {
  const [nameSearch, setNameSearch] = useState(null);
  const [techDocNameSearch, setTechDocNameSearch] = useState(null);
  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [modelSearchValue, setModelNameSearch] = useState(null);
  const [techDocSearch, setTechDocSearch] = useState(null);
  const [fgCodeSearchValue, setFgCodeSearch] = useState(null);

  const [searchedRows, setSearchedRows] = useState(techDocumentRecords);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({});
  const [brandSearch, setBrandSearch] = useState(null);
  const [categorySearch, setCategorySearch] = useState(null);
  const [familySearch, setFamilySearch] = useState(null);
  const [brickSearch, setBrickSearch] = useState(null);
  const [disableSearchButton, setDisableSearchButton] = useState(true);
  const [disableFilterButton, setdisableFilterButton] = useState(true);
  const [typeSearch, setTypeSearch] = useState(null);
  const [disableBrickDropdown, setDisableBrickDropdown] = useState(true);
  const [disableModelDropdown, setDisableModelDropdown] = useState(true);
  const [sendNotification, setSendNotification] = React.useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [releaseDate, setReleaseDate] = useState(null);
  const [brandId, setBrandId] = useState(null);
  const [modelId, setModelId] = useState(null);
  const [sortValue, setSortValue] = useState(null);
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("name");
  const [{ auth, technicalDocAccessRights }, dispatch] = useGlobalState();
  const loginParam = auth.ldapParam;
  console.log(loginParam, "loginParam in technical document list");
  const [file, setFile] = useState(null);
  const [selected, setSelected] = useState([]);
  const [disableUpdateButton, setDisbaleUpdateButton] = useState(true);
  const navigate = useNavigate();
  const loginUserId = auth.ldapParam.userId;
  const [disableCategoryDropdown, setDisableCategoryDropdown] = useState(true);
  const [disableFamilyDropdown, setDisableFamilyDropdown] = useState(true);
  const [isUpdateButton, setIsUpdateButton] = useState(true);
  const [familyName, setFamilyName] = useState("");
  const [brickName, setBrickName] = useState("");
  const [isSearchBtnClick, setIsSearchBtnClick] = useState(false);
  const [fileNameInEdit, SetFileNameInEdit] = useState(false);
  const [departErr, setDepartErr] = useState(false);
  const [modelErr, setModelErr] = useState(false);
  const [brandSearch_, setbrandSearch_] = useState(null);
  const [categorySearch_, setcategorySearch_] = useState(null);
  const [familySearch_, setfamilySearch_] = useState(null);
  const [brickSearch_, setbrickSearch_] = useState(null);
  const [typeSearch_, settypeSearch_] = useState(null);
  const [modelSearchValue_, setmodelSearchValue_] = useState(null);
  const [techDocSearch_, settechDocSearch_] = useState(null);
  const [formValues, setFormValues] = useState({
    createdOn: new Date(),
    createdBy: loginUserId,
    active: 1,
  });
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);
  const filesFormats = [
    "doc",
    "docx",
    "pdf",
    "ppt",
    "pptx",
    "xls",
    "xlsx",
    "csv",
    "exe",
    "mp4",
    "msi",
    "zip",
  ];
  const [historyOpen, setHistoryOpen] = useState(false);
  const [historyRows, setHistoryRows] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRowForMenu, setSelectedRowForMenu] = useState(null);
  const open = Boolean(anchorEl);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
    setError,
    clearErrors,
  } = useForm();

  useEffect(() => {
    reset(formData);
    setSendNotification(false);
  }, [openDialog]);



  const uppy = new Uppy({
    meta: { type: "avatar" },
    restrictions: { maxNumberOfFiles: 3 },
    autoProceed: true
  });

  uppy.use(Tus, {
    endpoint: "https://spms.dev.ril.com/technical_doc/api/upload",
    headers: { 'Access-Control-Allow-Origin': '*' },
    headers: { 'strict-origin-when-cross-origin': '*' },
    headers: { 'Content-Type': 'application/json' },
    headers: { 'accept': 'application/json' },
    headers: { 'AllowMethods': 'GET, POST, PUT, PATCH, DELETE, HEAD, OPTIONS' },
    headers: { 'Access-Control-Expose-Headers': '*' },
    headers: { 'AllowAllOrigins': true },
    headers: { 'AllowHeaders': "Authorization, X-Requested-With, X-Request-ID, X-HTTP-Method-Override, Upload-Length, Upload-Offset, Tus-Resumable, Upload-Metadata, Upload-Defer-Length, Upload-Concat, User-Agent, Referrer, Origin, Content-Type, Content-Length" },
    headers: { 'ExposeHeaders': 'Upload-Offset, Location, Upload-Length, Tus-Version, Tus-Resumable, Tus-Max-Size, Tus-Extension, Upload-Metadata, Upload-Defer-Length, Upload-Concat, Location, Upload-Offset, Upload-Length' },
    metadata: (file) => ({
      filename: file.name,
      filetype: file.type,
    }),
  });

  const handleMenuClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowForMenu(row);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setSelectedRowForMenu(null);
  };

  const handleDeleteTechDoc = async (row) => {
    try {
      setLoading(true);
      const payload = {
        userId: auth.ldapParam.userId,
        id: row.id,
      };
      const res = await deleteTechDocService(payload);

      if (res?.statusCode === 6) {
        showNotification(
          "Success",
          res.message ?? "Technical document deleted successfully",
          "success"
        );
        onClearClick();
      } else {
        showNotification(
          "Error",
          res?.message ?? "Failed to delete technical document",
          "error"
        );
      }
    } catch (err) {
      showNotification(
        "Error",
        err?.message ?? "Failed to delete technical document",
        "error"
      );
    } finally {
      setLoading(false);
      setConfirmDeleteOpen(false);
      setRowToDelete(null);
    }
  };

  const openDeleteConfirm = (row) => {
    setRowToDelete(row);
    setConfirmDeleteOpen(true);
  };

  const handleCloseDeleteConfirm = () => {
    setConfirmDeleteOpen(false);
    setRowToDelete(null);
  };

  // update menu dispatcher
  const handleMenuItem = (action) => {
    if (!selectedRowForMenu) return;

    switch (action) {
      case "edit":
        handleClickEditTechDoc(selectedRowForMenu);
        break;
      case "history":
        handleOpenHistory(selectedRowForMenu);
        break;
      case "download":
        handleDownload(selectedRowForMenu.id);
        break;
      case "delete":
        openDeleteConfirm(selectedRowForMenu);
        break;
      default:
        break;
    }
    handleCloseMenu();
  };


  useEffect(() => {
    const selectedRows =
      techDocumentRecords &&
      techDocumentRecords.filter(
        (row) =>
          row.name
            .toUpperCase()
            .includes(nameSearch && nameSearch.toUpperCase()) ||
          row.name.toUpperCase()
      );
    setSearchedRows(selectedRows);
    if (state) {
      setOrderBy("");
    }
  }, [nameSearch, techDocumentRecords]);

  const onBrandSelectedClick = async (id, name) => {
    setDisableCategoryDropdown(false);
    setDisableFamilyDropdown(true);
    setDisableBrickDropdown(true);
    setDisableModelDropdown(true);
    await fetchCategoryListOnSelectedBrand(id);
    setBrandId(id);
  };

  const clearBrand = async (autoC) => {
    const ele = autoC.current.getElementsByClassName(
      "MuiAutocomplete-clearIndicator"
    )[0];
    if (ele) ele.click();
  };

  const handleChangeRowsPerPage = async (event) => {
    const paginationValues = {
      pageNumber: 0,
      pageSize: +event.target.value,
      // brandId: brandSearch,
      // categoryId: categorySearch,
      // docTypeId: typeSearch,
      // name: modelSearchValue,
      // fgCode: fgCodeSearchValue,
    };

    await handleTableChanges(paginationValues, false, sortValue, orderBy, brandSearch_, categorySearch_, familySearch_, brickSearch_, typeSearch_, modelSearchValue_, techDocSearch_);
    setPage(0);
    setMaxPage(0);
    setRowsPerPage(+event.target.value);
  };

  const handleChangePage = async (event, newPage) => {
    if (newPage > page && newPage > maxPage) {
      setMaxPage(newPage);
      const paginationValues = {
        pageNumber: newPage,
        pageSize: rowsPerPage,
      };
      await handleTableChanges(paginationValues, true, sortValue, orderBy, brandSearch_, categorySearch_, familySearch_, brickSearch_, typeSearch_, modelSearchValue_, techDocSearch_);
    }
    setPage(newPage);
  };

  const searchText = async (e) => {
    setModelNameSearch(e.target.value);
    if (e.target.value === "" && brandSearch === null && categorySearch === null && familySearch === null && brickSearch === null && typeSearch === null && !techDocSearch) {
      onClearClick()
    } else {
      setDisableSearchButton(false);
      setdisableFilterButton(false);
    }
    setNameSearch(null);
  };

  const searchTechDocText = async (e) => {
    setTechDocSearch(e.target.value);
    if (e.target.value === "" && brandSearch === null && categorySearch === null && familySearch === null && brickSearch === null && typeSearch === null && !modelSearchValue) {
      onClearClick()
    } else {
      setDisableSearchButton(false);
      setdisableFilterButton(false);
    }
    setTechDocNameSearch(null);
  };
  const searchFgCode = async (e) => {
    setFgCodeSearch(e.target.value);
  };

  const onBrandClick = (id) => {
    fetchCatSearchDropdownList(id, brickSearch, familySearch, categorySearch);
    fetchFamSearchDropdownList(id, brickSearch, familySearch, categorySearch);
    fetchBrickSearchDropdownList(id, brickSearch, familySearch, categorySearch);
    setBrandSearch(id);
    setDisableSearchButton(false);
    setdisableFilterButton(false);
  };
  const onCategoryClick = (id) => {
    fetchBrandSearchDropdownList(brandSearch, brickSearch, familySearch, id);
    fetchFamSearchDropdownList(brandSearch, brickSearch, familySearch, id);
    fetchBrickSearchDropdownList(brandSearch, brickSearch, familySearch, id);
    setCategorySearch(id);
    setDisableSearchButton(false);
    setdisableFilterButton(false);
  };
  const onFamilySerachClick = (id) => {
    fetchBrandSearchDropdownList(brandSearch, brickSearch, id, categorySearch);
    fetchCatSearchDropdownList(brandSearch, brickSearch, id, categorySearch);
    fetchBrickSearchDropdownList(brandSearch, brickSearch, id, categorySearch);
    setFamilySearch(id);
    setDisableSearchButton(false);
    setdisableFilterButton(false);
  };
  const onBrickSearchClick = (id) => {
    fetchBrandSearchDropdownList(brandSearch, id, familySearch, categorySearch);
    fetchCatSearchDropdownList(brandSearch, id, familySearch, categorySearch);
    fetchFamSearchDropdownList(brandSearch, id, familySearch, categorySearch);
    setBrickSearch(id);
    setDisableSearchButton(false);
    setdisableFilterButton(false);
  };
  const onCategoryClickInModel = async (id, cateName) => {
    setDisableFamilyDropdown(false);
    setDisableBrickDropdown(true);
    setDisableModelDropdown(true);
    setValue("productCatFamilyMappingId", "");
    setValue("brickId", "");
    await fetchProductFamilyList(id);
    //setDisableSearchButton(false);
    //setdisableFilterButton(false);
  };
  const onTypeClick = (id) => {
    setTypeSearch(id);
    setDisableSearchButton(false);
    setdisableFilterButton(false);
  };

  const searchOnClick = async (type) => {
    try {
      setLoading(true);
      const requestBody = {
        brandId: brandSearch,
        categoryId: categorySearch,
        docTypeId: typeSearch,
        modelName: modelSearchValue && modelSearchValue.trim(),
        productFamilyId: familySearch,
        brickId: brickSearch,
        techDocDesc: techDocSearch,
        deptId: auth.ldapParam.deptId,
        userType: auth.ldapParam.userType,
        pageNumber: 0,
        pageSize: rowsPerPage ?? 10,

      };
      setbrandSearch_(brandSearch);
      setcategorySearch_(categorySearch);
      setfamilySearch_(familySearch);
      setbrickSearch_(brickSearch);
      settypeSearch_(typeSearch);
      setmodelSearchValue_(modelSearchValue);
      settechDocSearch_(techDocSearch);
      setIsSearchBtnClick(true);
      setSelected([]);
      setDisbaleUpdateButton(true)
      await fetchTechnicalDocumentDetails(requestBody, "name", true);
      setPage(0);
      setMaxPage(0);
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }

    setNameSearch(modelSearchValue);
  };
  const onFamilyClick = async (id, name) => {
    setFamilyName(name);
    setDisableBrickDropdown(false);
    setDisableModelDropdown(true);
    await fetchBrickListWithorWithoutFamily(id);
  };

  const handleClickEditTechDoc = (item) => {
    fetchModelsDeptList(item.brickId, item.brandId, item.docName).then((response) => {
      if (item) {
        reset(item);
      }

      setIsEditMode(true);
      fetchAllBrandsList();
      fetchBrickListOnSelectedBrandForUpload(item.brandId);

      fetchDocTypeList();
      fetchCategoryListOnSelectedBrand(item.brandId);
      fetchProductFamilyList(item.categoryId);
      fetchBrickListWithorWithoutFamily(item.productFamilyId);
      setFormValues({
        createdOn: item?.createdOn,
        createdBy: item.createdBy ? item.createdBy : 1,
        active: item?.isActive ? true : false,
      });
      setDisableCategoryDropdown(false);
      setDisableFamilyDropdown(false);
      setDisableBrickDropdown(false);
      setDisableModelDropdown(false);
      setFormData({ ...item });
      setOpenDialog(true);
      setValue("model_id", modelIdData)
      setValue("dept_Id", deptIdData)

    });

    setLoading(false);
  };

  const handleOpenHistory = async (row) => {
    console.log(row.id, "rowID")
    try {
      setLoading(true);
      const payload = { id: row.id }; // 2507000341
      const res = await getTechVersion(payload);
      console.log(res, "response from getTechVersion API");

      if (res && Array.isArray(res.data)) {
        setHistoryRows(res.data);
      } else if (res && res.data && Array.isArray(res.data.data)) {
        setHistoryRows(res.data.data);
      } else {
        setHistoryRows([]);
        showNotification("Info", "No history versions found");
      }

      setHistoryOpen(true);
    } catch (err) {
      showNotification(
        "Error",
        err?.message ?? "Failed to load document history",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCloseHistory = () => {
    setHistoryOpen(false);
    setHistoryRows([]);
  };

  const handleHistoryDownload = async (id) => {
    try {
      setLoading(true);
      const response = await DownloadTechDocHistoryService({ id: id });

      if (response) {
        try {
          // try JSON (URL) response first
          const parsedJson = JSON.parse(
            new TextDecoder().decode(response?.data)
          );
          window
            .open(parsedJson?.data?.downloadUrl, "_blank")
            .focus(); // window.open + focus
          showNotification("Success", "Succesfully Downloaded", "success");
        } catch (err) {
          // fallback to blob download
          const content = response.headers["content-type"];
          const [, filename] =
            response.headers["content-disposition"].split("filename=");
          const withoutFirstAndLast = filename.slice(1, -1);
          download(response.data, withoutFirstAndLast, content);
          // var _url = window.URL.createObjectURL(new Blob([response.data], { type: "application/octet-stream" }));
          // window.open(_url, "_blank").focus();
          showNotification("Success", "Succesfully Downloaded", "success");
        }
      } else {
        showNotification(
          "Info",
          response?.message ?? "Failed to download",
        );
      }
    } catch (err) {
      console.log("err", err);
      showNotification("Error", "Failed to download");
    } finally {
      setLoading(false);
    }
  };

  const onClearClick = async () => {
    setSelected([]);
    setDisbaleUpdateButton(true);
    setSearchClicked(false);
    setModelNameSearch("");
    setTechDocNameSearch("");
    setSearchedRows([]);
    setFgCodeSearch("");
    setBrandSearch(null);
    setDisableSearchButton(true);
    setdisableFilterButton(true);
    setCategorySearch(null);
    setTypeSearch(null);
    setIsApiCalled(false);
    setTotalElements(0);
    setFamilySearch(null);
    setBrickSearch(null);
    fetchCatSearchDropdownList();
    fetchBrandSearchDropdownList();
    fetchFamSearchDropdownList();
    fetchBrickSearchDropdownList();

    setbrandSearch_(null);
    setcategorySearch_(null);
    setfamilySearch_(null);
    setbrickSearch_(null);
    settypeSearch_(null);
    setmodelSearchValue_(null);
    settechDocSearch_(null);
    const requestBody = {
      deptId: auth.ldapParam.deptId,
      userType: auth.ldapParam.userType,
      pageNumber: 0,
      pageSize: rowsPerPage ?? 10,

    };
    setSelected([]);
    setDisbaleUpdateButton(true)
    setIsSearchBtnClick(false);
    await fetchTechnicalDocumentDetails(requestBody, "name", true);
    setPage(0);
    setMaxPage(0);
    // setRowsPerPage(10);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;
  const emptyRows =
    page > 0
      ? Math.max(0, (1 + page) * rowsPerPage - techDocumentRecords.length)
      : 0;

  const handleActiveChange = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
    if (newSelected.length !== 0) {
      setDisbaleUpdateButton(false);
    } else {
      setDisbaleUpdateButton(true);
    }
    const newSearchedRow = techDocumentRecords.map((currentRow) => {
      if (currentRow.id === id) {
        return {
          ...currentRow,
          isActive: event.target.checked,
        };
      }
      return currentRow;
    });
    setTechDocumentRecords(newSearchedRow);
  };

  const onChangeStatusSubmit = async () => {
    const resultRecords = [];
    selected.forEach((itemId) => {
      const tempItem = techDocumentRecords.find(
        (record) => record.id === itemId
      );
      if (tempItem) {
        resultRecords.push({
          active: tempItem.isActive,
          id: tempItem.id,
        });
      }
    });
    try {
      const res = await ChangeTechDocStatusService(resultRecords);
      if (res.statusCode == "6") {
        setSelected([]);
        showNotification("Success", res.message, "success");
        setDisbaleUpdateButton(true);
      } else {
        showNotification("Error", res.message, "error");
      }
    } catch (e) {
    } finally {
    }
  };
  const handleClickOpenBrandDialog = () => {
    fetchAllBrandsList();
    setOpenDialog(true);
    setIsEditMode(false);
    setModelIdData([]);
    setDeptIdData([]);
    setDisableCategoryDropdown(true);
    setDisableFamilyDropdown(true);
    setDisableBrickDropdown(true);
    setDisableModelDropdown(true);
  };
  const autoC = React.useRef(null);
  const autoC1 = React.useRef(null);
  const clearModel = async (autoCN) => {
    var object;
    if (autoCN != null && autoCN.current != null) {
      object = autoCN;
    }
    else
      if (autoC != null && autoC.current != null) {
        object = autoC;
      }
    if (object != null && object.current != null) {
      const ele = object.current.getElementsByClassName("MuiAutocomplete-clearIndicator")[0];
      if (ele) ele.click();
    }
  };

  const clearDept = async (autoCN) => {
    var object;
    if (autoCN != null && autoCN.current != null) {
      object = autoCN;
    }
    else
      if (autoC1 != null && autoC1.current != null) {
        object = autoC1;
      }
    if (object != null && object.current != null) {
      const ele = object.current.getElementsByClassName("MuiAutocomplete-clearIndicator")[0];
      if (ele) ele.click();
    }
  };
  const handleCloseUploadDialog = () => {
    setOpenDialog(false);
    clearModel(autoC);
    clearDept(autoC1);
    setFormData({});
  };

  const onSelectModel = (modelId) => {
    setModelId(modelId);
  };

  const onBrandSelect = (id) => {
    setBrandId(id);
    fetchBrickListOnSelectedBrandForUpload(id);
    setDisableBrickDropdown(false);
  };

  const onBrickSelect = (id) => {
    fetchModelsList(id, brandId);
    setDisableModelDropdown(false);
  };

  const onUploadSubmit = async (data) => {
    if (!isEditMode) {
      if (file === null) {
        showNotification("Error", "Please select file", "error");
        return;
      }
    }

    try {

      if (file != null) {
        const fileName = file?.name;
        var ext = fileName.substr(fileName.lastIndexOf(".") + 1);
        if (data.typeId == 9) {
          //  if (file.size > 3221225472) {
          if (file.size > 2147483648) {
            showNotification(
              "Error",
              "File size should not be greater than 2GB",
              "error"
            );
            return;
          }

        }
        if (data.typeId == 8) {
          // if (file.size > 3221225472) {
          if (file.size > 2147483648) {
            showNotification(
              "Error",
              "File size should not be greater than 2GB",
              "error"
            );
            return;
          }

        }
        if (data.typeId == 5) {
          if (file.size > 52428800) {
            showNotification(
              "Error",
              "File size should not be greater than 50MB",
              "error"
            );
            return;
          }
        }
        if (data.typeId == 4 || data.typeId == 1) {
          if (file.size > 10485760) {
            showNotification(
              "Error",
              "File size should not be greater than 10MB",
              "error"
            );
            return;
          }
        }
        if (data.typeId == 3) {
          if (file.size > 20971520) {
            showNotification(
              "Error",
              "File size should not be greater than 20MB",
              "error"
            );
            return;
          }
        }
        if (data.typeId == 2) {
          if (file.size > 157286400) {
            showNotification(
              "Error",
              "File size should not be greater than 150MB",
              "error"
            );
            return;
          }


        }
        const isRightFormat = filesFormats.includes(file && ext);
        if (!isRightFormat) {
          showNotification(
            "Error",
            "You can only upload doc/docx, pdf, ppt/pptx, xls/xlsx/csv, exe, mp4, zip, msi",
            "error"
          );
          return;
        }
      }

      let modelIDs = selectedModelIds.map((id) => {
        return id.modelId;
      });
      if (modelIDs.length <= 0) {
        showNotification(
          "Error",
          "Please select model",
          "error"
        );
        return;
      }

      let deptIDs = selectedDeptIds.map((id) => {
        return id.departmentId;
      });
      if (deptIDs.length <= 0) {
        showNotification(
          "Error",
          "Please select department",
          "error"
        );
        return;
      }
      setLoading(true);
      const param = {
        docTypeId: data.typeId,
        modelId: modelIDs,
        createdBy: loginParam.userId,
        isDownloadAble: data.isDownloadAble,
        sendNotification,
        shortDesc: data.shortDesc ? data.shortDesc.trim() : null,
        id: data.id,
        techDocDesc: data.techDocDesc ? data.techDocDesc.trim() : null,
        modifiedBy: null,
        deptId: deptIDs,
      };
      const requestBody = {
        deptId: auth.ldapParam.deptId,
        userType: auth.ldapParam.userType,
        pageNumber: page,
        pageSize: rowsPerPage,

      };
      if (data.typeId == 8 || data.typeId == 9) {

        if (file) {
          addFileToUppy(file);

          console.info("before uploads:");
          uppy.upload().then((result) => {
            console.info("Successful uploads:", result.successful);

            if (result.successful.length > 0) {
              //  uploadedFiles.push(...result.successful);
              // return result.successful[0].uploadURL;
              // const uploadResponseSoftware =  await UploadFileServiceSoftware(file, param, file.name, file.size,result.successful[0].uploadURL);
              /* const uploadResponseSoftware = !isEditMode
                  ? await UploadFileServiceSoftware(file, param)
                 : await UpdateFileServiceSoftware(file, param);
                if (uploadResponseSoftware.statusCode === 6) {
                  handleCloseUploadDialog();
                  setSendNotification(false);
                  showNotification("Success", uploadResponseSoftware.message, "success");
                  setFile(null);
                  setModelId(null);
                  setDepartErr(false)
                  onClearClick()
                  setDisableSearchButton(true);
                  setdisableFilterButton(true);
                  //fetchTechnicalDocumentDetails(requestBody,"name", true);
                } else {
                  showNotification("Error", uploadResponseSoftware.message, "error");
              }*/
              uploadDoc(file, param, result.successful[0].uploadURL);
            }

            if (result.failed.length > 0) {
              console.error("Errors:");
              showNotification("Error", "Failed to upload");
              result.failed.forEach((file) => {
                console.error("Errors-->" + file.error);
              });
            }

          });
          //  if(returnURL){

        }
        else {
          const updateResponseSoftware = await UpdateFileServiceSoftware(file, param, null, null, null);
          if (updateResponseSoftware.statusCode === 6) {
            handleCloseUploadDialog();
            setSendNotification(false);
            showNotification("Success", updateResponseSoftware.message, "success");
            setFile(null);
            setModelId(null);
            setDepartErr(false)
            onClearClick()
            setDisableSearchButton(true);
            setdisableFilterButton(true);
            //fetchTechnicalDocumentDetails(requestBody,"name", true);
          } else {
            showNotification("Error", updateResponseSoftware.message, "error");
          }
        }
      }
      else {
        const uploadResponse = !isEditMode
          ? await UploadFileService(file, param)
          : await UpdateFileService(file, param);
        if (uploadResponse.statusCode === 6) {
          handleCloseUploadDialog();
          setSendNotification(false);
          showNotification("Success", uploadResponse.message, "success");
          setFile(null);
          setModelId(null);
          setDepartErr(false)
          onClearClick()
          setDisableSearchButton(true);
          setdisableFilterButton(true);
          //fetchTechnicalDocumentDetails(requestBody,"name", true);
        } else {
          showNotification("Error", uploadResponse.message, "error");
        }
      }
    } catch (err) {
      showNotification("Error", err?.message ?? "Failed to upload");
    } finally {
      setLoading(false);
    }

  };


  const addFileToUppy = (file) => {
    try {
      uppy.addFile({
        source: "file input",
        name: file.name,
        type: file.type,
        data: file
      });

    } catch (err) {
      if (err.isRestriction) {
        // handle restrictions
        console.log("Restriction error:", err);
      } else {
        // handle other errors
        console.error("Restriction error:-->" + err);
      }
    }
    console.log("after adding file");


  };
  const uploadDoc = async (file, param, uploadURL) => {
    //const uploadResponseSoftware =  await UploadFileServiceSoftware(file, param, file.name, file.size,uploadURL);
    const uploadResponseSoftware = !isEditMode
      ? await UploadFileServiceSoftware(file, param, file.name, file.size, uploadURL)
      : await UpdateFileServiceSoftware(file, param, file.name, file.size, uploadURL);
    if (uploadResponseSoftware.statusCode === 6) {
      handleCloseUploadDialog();
      setSendNotification(false);
      showNotification("Success", uploadResponseSoftware.message, "success");
      setFile(null);
      setModelId(null);
      setDepartErr(false)
      onClearClick()
      setDisableSearchButton(true);
      setdisableFilterButton(true);
      //fetchTechnicalDocumentDetails(requestBody,"name", true);
    } else {
      showNotification("Error", uploadResponseSoftware.message, "error");
    }
  }
  // Uplaods all files currently selected
  const upload = async () => {
    console.info("before uploads:");
    uppy.upload().then((result) => {
      console.info("Successful uploads:", result.successful);

      if (result.successful.length > 0) {
        //  uploadedFiles.push(...result.successful);
        return result.successful[0].uploadURL;
      }

      if (result.failed.length > 0) {
        console.error("Errors:");
        showNotification("Error", "Failed to upload");
        result.failed.forEach((file) => {
          console.error("Errors-->" + file.error);
        });
      }

    });
  }

  const handleDownload = async (id) => {
    try {
      setLoading(true);
      const response = await DownloadTechDocService(id);

      if (response) {
        console.log("response-->" + response);
        console.log("response-->" + response?.data);
        try {
          var parsedJson = JSON.parse(new TextDecoder().decode(response?.data));
          window.open(parsedJson?.data?.downloadUrl, "_blank").focus(); // window.open + focus
          showNotification("Success", "Succesfully Downloaded", "success");
        }
        catch (err) {
          const content = response.headers["content-type"];
          const [, filename] = response.headers['content-disposition'].split('filename=');
          const withoutFirstAndLast = filename.slice(1, -1);
          download(response.data, withoutFirstAndLast, content);
          //var _url = window.URL.createObjectURL(new Blob([response.data], { type: "application/octet-stream" }));
          //  window.open(_url, "_blank").focus(); // window.open + focus
          showNotification("Success", "Succesfully Downloaded", "success");
        }

        // console.log("view1-->"+parsedJson?.data?.downloadUrl);
        // console.log("response-->"+response?.data?.downloadUrl);
        // console.log("response-->"+response?.downloadUrl);
        //  console.log("response-->"+response?.message);
        //    const content = response.headers["content-type"];
        //    const [, filename] = response.headers['content-disposition'].split('filename=');
        //     const withoutFirstAndLast = filename.slice(1, -1);
        //download(response.data, withoutFirstAndLast , content);

      } else {
        showNotification("Info", response?.message ?? "Failed to download");
      }
    } catch (err) {
      console.log("err", err);
      showNotification("Error", "Failed to download");
    } finally {
      setLoading(false);
    }
  };

  const handleRequestSort = (event, property) => {
    setSelected([]);
    setDisbaleUpdateButton(true)
    if (!state) {
      const requestBody = {
        brandId: brandSearch_,
        categoryId: categorySearch_,
        modelName: modelSearchValue_ && modelSearchValue_.trim(),
        productFamilyId: familySearch_,
        docTypeId: typeSearch_,
        brickId: brickSearch_,
        techDocDesc: techDocSearch_,
        deptId: auth.ldapParam.deptId,
        userType: auth.ldapParam.userType,
        name: modelSearchValue,
        pageNumber: 0,
        pageSize: rowsPerPage,
      };
      const isAsc = orderBy === property && order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(property);
      fetchTechnicalDocumentDetails(requestBody, property, isAsc);
      setSortValue(isAsc ? "DESC" : "ASC");
      setPage(0);
      setMaxPage(0);
    }
  };

  const handleChange = (event) => {
    setSendNotification(event.target.checked);
  };

  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 6 }}>
        <Grid container spacing={2} sx={{ px: 0, mt: 1 }} display="flex">
          <Grid item xs={8} sx={{ mb: 1 }}>
            <Typography
              align="left"
              sx={{ mr: "auto", color: "#003f93" }}
              variant="h6">
              {state ? (
                <IconButton sx={{ color: "#567aac" }}>
                  <ArrowBackIcon
                    onClick={() =>
                      navigate(`/notifications`, {
                        state: {
                          isUnRead: true,
                          pageNo: state?.pageNo,
                          typeId: state?.typeId,
                          isFromRead: state?.isFromRead,
                        },
                      })
                    }
                  />
                </IconButton>
              ) : (
                ""
              )}
              Technical Document ( {totalElements ? totalElements : 0} )
            </Typography>
          </Grid>
          {state && state.isUnRead ? (
            ""
          ) : (
            <Grid item xs={4} sx={{ mb: 1 }}>
              <Typography align="right">
                {technicalDocAccessRights.addDelete ? (
                  <Tooltip title="Update  Status">
                    <Button
                      variant="contained"
                      sx={{ ml: 1 }}
                      className="button-primary-alt-contained"
                      onClick={onChangeStatusSubmit}
                      disabled={disableUpdateButton}>
                      Status Update
                      {selected.length !== 0 &&
                        ` (${Object.keys(selected).length})`}
                    </Button>
                  </Tooltip>
                ) : null}
                {technicalDocAccessRights.write ? (
                  <Tooltip title="Upload">
                    <Button
                      variant="contained"
                      onClick={handleClickOpenBrandDialog}
                      sx={{ ml: 1 }}
                      className="button-primary-alt-contained"
                      startIcon={<FileUploadIcon />}>
                      Upload
                    </Button>
                  </Tooltip>
                ) : null}
              </Typography>
            </Grid>
          )}
          {state?.isUnRead ? (
            ""
          ) : (
            <Grid item xs={2} md={2} sx={{ mb: 1 }}>
              <Typography align="right">
                <div className="searchContainer">
                  <FormControl
                    sx={{ m: 0, minWidth: 150, maxWidth: 160, ml: 0 }}
                    size="small">
                    <InputLabel
                      id="demo-simple-select-label"
                      shrink={
                        brandSearch === null || (brandSearch !== null && true)
                      }>
                      <span className="searchFields"> Brand</span>
                    </InputLabel>
                    <Select
                      name="id"
                      label="Brand"
                      autoComplete="off"
                      value={brandSearch}>
                      {brandDropDownList &&
                        brandDropDownList.map((d) => {
                          return (
                            <MenuItem
                              native
                              key={d.id}
                              onClick={() => onBrandClick(d.id)}
                              sx={{ width: "100%" }}
                              value={d.id}
                              size="small">
                              {d.name}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </div>
              </Typography>
            </Grid>
          )}
          {state?.isUnRead ? (
            ""
          ) : (
            <Grid item xs={2} md={2} sx={{ mb: 1 }}>
              <Typography align="right">
                <div className="searchContainer">
                  <FormControl
                    sx={{ m: 0, minWidth: 150, maxWidth: 160 }}
                    size="small">
                    <InputLabel
                      id="demo-simple-select-label"
                      shrink={
                        categorySearch === null ||
                        (categorySearch !== null && true)
                      }>
                      <span className="searchFields"> Category </span>
                    </InputLabel>
                    <Select
                      name="id"
                      label="Category"
                      autoComplete="off"
                      value={categorySearch}>
                      {categoryList &&
                        categoryList.map((d) => {
                          return (
                            <MenuItem
                              native
                              key={d.id}
                              onClick={() => onCategoryClick(d.id)}
                              sx={{ width: "100%" }}
                              value={d.id}
                              size="small">
                              {d.name}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </div>
              </Typography>
            </Grid>
          )}

          {state?.isUnRead ? (
            ""
          ) : (
            <Grid item xs={2} md={2} sx={{ mb: 1 }}>
              <Typography align="right">
                <div className="searchContainer">
                  <FormControl
                    sx={{ m: 0, minWidth: 150, maxWidth: 160 }}
                    size="small">
                    <InputLabel
                      id="demo-simple-select-label"
                      shrink={
                        familyName === null || (familyName !== null && true)
                      }>
                      <span className="searchFields"> Family </span>
                    </InputLabel>
                    <Select
                      name="id"
                      label="Family"
                      autoComplete="off"
                      value={familySearch}>
                      {familyList &&
                        familyList.map((d) => {
                          return (
                            <MenuItem
                              native
                              key={d.id}
                              onClick={() => onFamilySerachClick(d.id)}
                              sx={{ width: "100%" }}
                              value={d.id}
                              size="small">
                              {d.name}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </div>
              </Typography>
            </Grid>
          )}

          {state?.isUnRead ? (
            ""
          ) : (
            <Grid item xs={2} md={2} sx={{ mb: 1 }}>
              <Typography align="right">
                <div className="searchContainer">
                  <FormControl
                    sx={{ m: 0, minWidth: 150, maxWidth: 160 }}
                    size="small">
                    <InputLabel
                      id="demo-simple-select-label"
                      shrink={
                        brickSearch === null || (brickSearch !== null && true)
                      }>
                      <span className="searchFields"> Brick </span>
                    </InputLabel>
                    <Select
                      name="id"
                      label="Brick"
                      autoComplete="off"
                      value={brickSearch}>
                      {brickDropdownList &&
                        brickDropdownList.map((d) => {
                          return (
                            <MenuItem
                              native
                              key={d.categoryId}
                              onClick={() => onBrickSearchClick(d.id)}
                              sx={{ width: "100%" }}
                              value={d.id}
                              size="small">
                              {d.name}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </div>
              </Typography>
            </Grid>
          )}

          {state?.isUnRead ? (
            ""
          ) : (
            <Grid item xs={2} md={2} sx={{ mb: 1 }}>
              <Typography>
                <FormControl
                  sx={{ m: 0, minWidth: 150, maxWidth: 160 }}
                  size="small">
                  <InputLabel
                    id="demo-simple-select-label"
                    shrink={
                      typeSearch === null || (typeSearch !== null && true)
                    }>
                    <span className="searchFields"> Type </span>
                  </InputLabel>
                  <Select
                    name="id"
                    label="Type"
                    autoComplete="off"
                    value={typeSearch}>
                    {docTypeList &&
                      docTypeList.map((d) => {
                        return (
                          <MenuItem
                            native
                            key={d.id}
                            onClick={() => onTypeClick(d.id)}
                            sx={{ width: "100%" }}
                            value={d.id}
                            size="small">
                            {d.description}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
              </Typography>
            </Grid>
          )}
          {state?.isUnRead ? (
            ""
          ) : (
            <Grid item xs={2} md={2} sx={{ mb: 1 }}>
              <Typography>
                <FormControl
                  sx={{ m: 0, minWidth: 150, maxWidth: 160 }}
                  size="small">
                  <TextField
                    className="stepperFormInput"
                    label="Model Name"
                    onChange={searchText}
                    InputLabelProps={{ shrink: true }}
                    value={modelSearchValue}
                    size="small"
                    autoComplete="off"
                  />
                </FormControl>
              </Typography>
            </Grid>
          )}
          {state?.isUnRead ? (
            ""
          ) : (
            <Grid item xs={2} md={2} sx={{ mb: 1 }}>
              <Typography>
                <FormControl
                  sx={{ m: 0, minWidth: 150, maxWidth: 160, ml: 0 }}
                  size="small">
                  <TextField
                    className="stepperFormInput"
                    label="Doc Desc"
                    onChange={searchTechDocText}
                    InputLabelProps={{ shrink: true }}
                    value={techDocNameSearch}
                    size="small"
                    autoComplete="off"
                  />
                </FormControl>
              </Typography>
            </Grid>
          )}

          {state?.isUnRead ? (
            ""
          ) : (
            <Grid item xs={0} md={0} sx={{ mb: "0" }}>
              <Typography align="right">
                <Tooltip title="Search">
                  <IconButton
                    color="primary"
                    aria-label="Search"
                    component="label"
                    disabled={disableSearchButton}>
                    <SearchIcon
                      sx={{ height: "35px", width: "35px" }}
                      onClick={() => searchOnClick("firstName")}
                    />
                  </IconButton>
                </Tooltip>
              </Typography>
            </Grid>
          )}
          {state?.isUnRead ? (
            ""
          ) : (
            <Grid item xs={1} md={1} sx={{ mb: "1" }}>
              <Typography align="left">
                <Tooltip title="Clear Search">
                  <IconButton
                    color="primary"
                    aria-label="Clear"
                    component="label"
                    disabled={disableFilterButton}>
                    <FilterAltOffSharpIcon
                      sx={{ height: "32px", width: "32px" }}
                      onClick={() => onClearClick()}
                    />
                  </IconButton>
                </Tooltip>
              </Typography>
            </Grid>
          )}
          <Grid item xs={12} mb={4}>
            {/* {searchedRows && searchedRows.length > 0 ? ( */}
            <Paper elevation={3} variant="elevation">
              <TableContainer sx={{ maxHeight: 7120 }}>
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  aria-labelledby="tableTitle"
                  size="small">
                  <EnhancedTableHead
                    numSelected={selected.length}
                    rowCount={searchedRows.length}
                    onRequestSort={handleRequestSort}
                    order={order}
                    orderBy={orderBy}
                    searchClicked={searchClicked}
                    loginParam={loginParam}
                    sorting={state?.sorting}
                    state={state}
                  />
                  {searchedRows && searchedRows.length > 0 ? (
                    <TableBody sx={{ mt: 2 }}>
                      {searchedRows
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => {
                          const isItemSelected = isSelected(row.id);
                          const labelId = `enhanced-table-checkbox-${index}`;
                          const isTdRequired = row.isTdRequired;
                          return (
                            <TableRow
                              hover
                              role="checkbox"
                              tabIndex={-1}
                              key={row.userId}
                              aria-checked={isItemSelected}
                              selected={isItemSelected}
                              onMouseOver={(event) => checkStyle(event, 1)}
                              onMouseOut={(event) => checkStyle(event, 2)}>
                              {isTdRequired ? (
                                <TableCell
                                  size="medium"
                                  key={"techDocDesc"}
                                  rowSpan={row.size}>
                                  {`${row["techDocDesc"]}` === "null"
                                    ? "-"
                                    : `${row["techDocDesc"]}`}
                                </TableCell>
                              ) : (
                                ""
                              )}
                              <TableCell
                                size="medium"
                                key={"name"}
                                title={
                                  `${row["modelName"]}`
                                    ? `${row["modelName"]}`
                                    : ""
                                }>
                                {`${row["name"]}` ?? "-"}-
                                {(`${row["modelName"]}` &&
                                  `${row["modelName"]}`?.slice(0, 20)) ||
                                  "-"}{" "}
                                {`${row["modelName"]}` &&
                                  `${row["modelName"]}`.length > 20
                                  ? "..."
                                  : ""}{" "}
                              </TableCell>
                              <TableCell size="medium" key={"brandName"}>
                                {`${row["brandName"]}` ?? "-"}
                              </TableCell>
                              <TableCell size="medium" key={"categoryName"}>
                                {row["categoryName"] ?? "-"}
                              </TableCell>
                              <TableCell
                                size="medium"
                                key={"productFamilyName"}>
                                {row["productFamilyName"] ?? "-"}
                              </TableCell>
                              <TableCell size="medium" key={"brickName"}>
                                {row["brickName"] ?? "-"}
                              </TableCell>
                              <TableCell size="medium" key={"description"}>
                                {row["description"] ?? "-"}
                              </TableCell>
                              <TableCell
                                size="medium"
                                key={"createdByFirstName"}
                                style={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}>
                                {row["createdByFirstName"] ?? "-"}{" "}
                                {row["createdByLastName"] ?? "-"}
                              </TableCell>
                              {isTdRequired ? (
                                <TableCell
                                  align="center"
                                  size="small"
                                  rowSpan={row.size}>
                                  {" "}
                                  {technicalDocAccessRights.addDelete ? (
                                    <Checkbox
                                      color="primary"
                                      checked={(isItemSelected, row.isActive)}
                                      classes={{ root: "custom-checkbox-root" }}
                                      onClick={(event) =>
                                        handleActiveChange(event, row.id)
                                      }
                                      inputProps={{
                                        "aria-labelledby": labelId,
                                      }}
                                    />
                                  ) : null}
                                </TableCell>
                              ) : null}

                              {isTdRequired ? (
                                <TableCell
                                  width="1%"
                                  align="center"
                                  size="medium"
                                  key={"Action"}
                                  rowSpan={row.size}
                                >
                                  <MoreVertIcon
                                    onClick={(event) => {
                                      handleMenuClick(event, row);
                                    }}
                                    fontSize="small"
                                    cursor="pointer"
                                    sx={{ cursor: "pointer", color: "#567aac" }}
                                  />
                                  <Menu
                                    id="tech-doc-actions-menu"
                                    className="listingPopOver"
                                    anchorEl={anchorEl}
                                    open={open}
                                    onClose={handleCloseMenu}
                                    MenuListProps={{
                                      "aria-labelledby": "tech-doc-actions-button",
                                    }}
                                  >
                                    {technicalDocAccessRights.write && (
                                      <MenuItem onClick={() => handleMenuItem("edit")}>
                                        <EditIcon
                                          fontSize="medium"
                                          color="disabled"
                                          sx={{ mr: 1 }}
                                        />
                                        Edit
                                      </MenuItem>
                                    )}
                                    <MenuItem onClick={() => handleMenuItem("history")}>
                                      <HistoryIcon
                                        fontSize="medium"
                                        color="disabled"
                                        sx={{ mr: 1 }}
                                      />
                                      History
                                    </MenuItem>
                                    {loginParam.rilUser && (
                                      <MenuItem
                                        disabled={!selectedRowForMenu?.isDownloadable}
                                        onClick={() => handleMenuItem("download")}
                                      >
                                        <FileDownloadIcon
                                          fontSize="medium"
                                          color="disabled"
                                          sx={{ mr: 1 }}
                                        />
                                        Download
                                      </MenuItem>
                                    )}
                                    {(loginParam?.userType === "Main Admin" ||
                                      loginParam?.userType === "Domain Admin") &&
                                      technicalDocAccessRights.addDelete && (
                                        <MenuItem onClick={() => handleMenuItem("delete")}>
                                          <DeleteIcon
                                            fontSize="medium"
                                            color="disabled"
                                            sx={{ mr: 1 }}
                                          />
                                          Delete
                                        </MenuItem>
                                      )}
                                  </Menu>
                                </TableCell>
                              ) : null}
                            </TableRow>
                          );
                        })}
                      {emptyRows > 0 && (
                        <TableRow
                          style={{
                            height: 33 * emptyRows,
                          }}>
                          <TableCell colSpan={6} />
                        </TableRow>
                      )}
                    </TableBody>
                  ) : isApiCalled &&
                    searchedRows &&
                    searchedRows.length === 0 ? (
                    <TableBody>
                      <TableRow>
                        {noRecord ? (
                          <TableCell colSpan={10}>
                            <RecordNotFound />
                          </TableCell>
                        ) : (
                          <TableCell colSpan={6} />
                        )}
                      </TableRow>
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={12}>
                          <div className="highlighBox">
                            <p>Please select filter</p>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
              {!state?.isUnRead && searchedRows && searchedRows.length > 0 ? (
                <TablePagination
                  className="newPagination"
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  component="div"
                  count={totalElements}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              ) : null}
            </Paper>

          </Grid>
        </Grid>
        <UploadDoc
          openDialog={openDialog}
          handleClose={handleCloseUploadDialog}
          register={register}
          handleSubmit={handleSubmit}
          errors={errors}
          onUploadSubmit={onUploadSubmit}
          allBrands={allBrands}
          modelList={modelList}
          docTypeList={docTypeList}
          onSelectModel={onSelectModel}
          modelDescription={modelDescription}
          releaseDate={releaseDate}
          setReleaseDate={setReleaseDate}
          setFile={setFile}
          onBrandSelect={onBrandSelect}
          brickListForUpload={brickListForUpload}
          onBrickSelect={onBrickSelect}
          handleChange={handleChange}
          sendNotification={sendNotification}
          disableBrickDropdown={disableBrickDropdown}
          disableModelDropdown={disableModelDropdown}
          isEditMode={isEditMode}
          formData={formData}
          disableCategoryDropdown={disableCategoryDropdown}
          disableFamilyDropdown={disableFamilyDropdown}
          setCategoryListOnBrandId={setCategoryListOnBrandId}
          setValue={setValue}
          setIsUpdateButton={setIsUpdateButton}
          onFamilyClick={onFamilyClick}
          productFamilyList={productFamilyList}
          onCategoryClick={onCategoryClick}
          onBrandSelectedClick={onBrandSelectedClick}
          categoryListOnBrandId={categoryListOnBrandId}
          onCategoryClickInModel={onCategoryClickInModel}
          brickList={brickList}
          setBrickName={setBrickName}
          setSelectedModelIds={setSelectedModelIds}
          selectedModelIds={selectedModelIds}
          selectedDeptIds={selectedDeptIds}
          setSelectedDeptlIds={setSelectedDeptlIds}
          setError={setError}
          departmentList={departmentList}
          clearErrors={clearErrors}
          clearModel={clearModel}
          clearDept={clearDept}
          autoC={autoC}
          autoC1={autoC1}
          SetFileNameInEdit={SetFileNameInEdit}
          departErr={departErr}
          modelErr={modelErr}
          modelIdData={modelIdData}
          deptIdData={deptIdData}
        />
        <Dialog
          open={historyOpen}
          onClose={handleCloseHistory}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle
            sx={{
              bgcolor: "primary.main",
              color: "primary.contrastText",
              py: 1.5,
            }}
          >
            Document History
          </DialogTitle>
          <DialogContent dividers>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Sr No</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell align="center">Download</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {historyRows.map((h) => (
                  <TableRow key={h.id}>
                    <TableCell>{h.rowNum}</TableCell>
                    <TableCell>{h.fileName}</TableCell>
                    <TableCell align="center">
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={() => handleHistoryDownload(h.id)}
                      >
                        Download
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
                {historyRows.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      No history available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleCloseHistory}
              variant="contained"
              color="primary"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={confirmDeleteOpen}
          onClose={handleCloseDeleteConfirm}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle
            sx={{ bgcolor: "primary.main", color: "primary.contrastText", py: 1.5 }}
          >
            Confirm Delete
          </DialogTitle>
          <DialogContent dividers>
            Are you sure you want to delete this technical document?
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDeleteConfirm} variant="outlined">
              Cancel
            </Button>
            <Button
              onClick={() => rowToDelete && handleDeleteTechDoc(rowToDelete)}
              variant="contained"
              color="error"
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </>
  );
}

function EnhancedTableHead({
  onRequestSort,
  order,
  orderBy,
  searchClicked,
  loginParam,
  sorting,
  state,
}) {
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow key={"1"}>
        {TECHNICAL_DOCUMENT_LISTING_COLUMNS.map((headCell) => (
          <TableCell
            size="small"
            variant="head"
            className="tableHeader"
            sx={{ pt: 1.5, pb: 1.5 }}
            key={headCell.userId}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            style={{
              minWidth: headCell.minWidth,
              fontWeight: "bold",
              color: "#003A6B",
            }}>
            <TableSortLabel
              active={sorting ? false : orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              disabled={
                (headCell.id === "action" ||
                  headCell.id === "active" ||
                  (searchClicked === false &&
                    (headCell.id === "name" ||
                      headCell.id === "brandName" ||
                      headCell.id === "categoryName" ||
                      headCell.id === "description"))) &&
                true
              }
              hideSortIcon={true}
              hidden={
                loginParam.rilUser === false
                  ? headCell.id === "action"
                    ? true
                    : false
                  : false
              }>
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
